<template>
  <div
    class="sell"
    :class="{
      'sell-pc': showPc,
      'sell-default':theme == 'default'
    }"
    v-if="isSellingFeatures"
  >
    <div class="sell-item" :class="{'center':typographicStyle=='center'}" v-for="(item, index) in sellingFeatures" :key="index">
      <p v-if="item.text">
        <i class="iconfont" :class="[`icon-cm-${item.icon}`]"></i>
        <span class="page_text_font">{{ item.text }}</span>
      </p>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  computed: {
    ...mapState({
      isSellingFeatures: ({ options }) => options?.theme?.pages?.product?.config?.is_selling_features,
      showPc: ({ options }) => options?.theme?.pages?.product?.config?.only_show_pc,
      sellingFeatures: ({ options }) => options?.theme?.pages?.product?.config?.selling_features,
      typographicStyle: ({ options }) => options?.theme?.pages?.product?.config?.typographic_style || 'left', // 只有default有的属性
      theme: ({ theme_name }) =>  theme_name
    }),
  },
}
</script>
<style scoped lang='scss'>
.sell {
  margin-top: 20px;
  display: block;
  .sell-item {
    margin-bottom: 14px;
    p {
      display: flex;
      margin-bottom: 0;
      line-height: 20px;
      i {
        font-size: 18px;
        margin-right: 12px;
      }
    }
  }
  .center {
      p {
          justify-content: center;
      }
  }
  div:last-child {
    margin-bottom: 0 !important;
  }
}
.sell-default {
    margin-bottom: 20px;
}
@media screen and (max-width: 768px) {
  .sell-pc {
    display: none;
  }
}
</style>